interface OptionIcon {
  url: string;
  alt: string;
}

interface OptionIconsData {
  [key: string]: OptionIcon;
}

declare global {
  interface Window {
    wakoOptionIcons?: OptionIconsData;
  }
}

export const useOptionIcons = () => {
  /**
   * カテゴリーと値に基づいてオプションアイコンのURLを取得
   * @param category - アイコンのカテゴリー（product, bean, package, 等）
   * @param value - 選択肢の値（freeze-dried, my-bean, stick, 等）
   * @param productType - パッケージ選択時の商品タイプ（必要に応じて）
   * @returns アイコンのURL、または見つからない場合はundefined
   */
  const getOptionIcon = (
    category: string,
    value: string,
    productType?: string
  ): string | undefined => {
    const optionIcons = window.wakoOptionIcons;
    if (!optionIcons) {
      return undefined;
    }

    let iconKey: string;

    // パッケージタイプの場合は商品タイプ別に管理
    if (category === 'package' && productType) {
      const productPrefix = productType === 'freeze-dried' ? 'fd' : 
                           productType === 'liquid-concentrate' ? 'nk' : 'st';
      iconKey = `icon_${productPrefix}_${category}_${value.replace(/-/g, '_')}`;
    } else {
      // 一般的なアイコンキー生成
      iconKey = `icon_${category}_${value.replace(/-/g, '_')}`;
    }

    const icon = optionIcons[iconKey];
    return icon?.url;
  };

  /**
   * アイコンの完全な情報（URLとalt）を取得
   * @param category - アイコンのカテゴリー
   * @param value - 選択肢の値
   * @param productType - パッケージ選択時の商品タイプ（必要に応じて）
   * @returns アイコンの情報、または見つからない場合はundefined
   */
  const getOptionIconData = (
    category: string,
    value: string,
    productType?: string
  ): OptionIcon | undefined => {
    const optionIcons = window.wakoOptionIcons;
    if (!optionIcons) {
      return undefined;
    }

    let iconKey: string;

    if (category === 'package' && productType) {
      const productPrefix = productType === 'freeze-dried' ? 'fd' : 
                           productType === 'liquid-concentrate' ? 'nk' : 'st';
      iconKey = `icon_${productPrefix}_${category}_${value.replace(/-/g, '_')}`;
    } else {
      iconKey = `icon_${category}_${value.replace(/-/g, '_')}`;
    }

    return optionIcons[iconKey];
  };

  /**
   * Option Iconsデータが利用可能かどうかを確認
   * @returns データが利用可能な場合はtrue
   */
  const isOptionIconsAvailable = (): boolean => {
    return !!(window.wakoOptionIcons && Object.keys(window.wakoOptionIcons).length > 0);
  };

  return {
    getOptionIcon,
    getOptionIconData,
    isOptionIconsAvailable,
  };
}; 